import { EArticleClass, EUserType, IImage, TArticleDetail, UserTypeUtil } from 'shared/models';
import { Region } from '@lemon8/web-app-shared/i18n';
import { IArticleGPTInfo } from 'shared/atoms';

export interface Article {
  groupId: string;

  imprId?: string;

  articleClass: EArticleClass;

  articleRegion?: Region;

  author: ArticleAuthor;

  title: string;

  shortContent: string;

  imageList: IImage[];

  largeImage: IImage;

  articleLikes: number;

  ocrTextArr?: string[];

  gptInfo?: Partial<IArticleGPTInfo>;
}

export interface ArticleAuthor {
  userId: string;

  nickName: string;

  linkName: string;

  userType: EUserType;

  description: string;

  avatar: string;

  publishCount: number;

  authInfo: any;

  followerCount?: number;
}

export const LegacyArticleUtil = {
  getArticlePath: (article: Article | TArticleDetail): string => {
    return `/${UserTypeUtil.getLinkNamePrefix(article.author.userType)}${article.author.linkName}/${article.groupId}`;
  },

  getArticleHref: (article: Article | TArticleDetail): string => {
    const path = LegacyArticleUtil.getArticlePath(article);
    if (article.articleRegion) {
      return `${path}?region=${article.articleRegion}`;
    }
    return path;
  },

  getAuthorPath: (article: Article | TArticleDetail): string => {
    return `/${UserTypeUtil.getLinkNamePrefix(article.author.userType)}${article.author.linkName}`;
  },
};
